import React from 'react';

// Define the props for the FormattedText component
// This component accepts children and an optional className for styling
// The preserveFormatting prop can be used to indicate whether to preserve whitespace and line breaks
//

interface FormattedTextProps {
  children: React.ReactNode;
  className?: string;
  preserveFormatting?: boolean;
}

const FormattedText = ({
  className = '',
  children,
  preserveFormatting = false,
}: FormattedTextProps) => {
  return (
    <div
      className={`formatted-text ${preserveFormatting ? 'preserve-formatting' : ' '} ${className}`}
    >
      {children}
    </div>
  );
};

export default FormattedText;
